import * as condition from './list-filter/condition';
import { ShortDateValueConverter } from '../../resources/value-converters/short-date';
import { SecurityService } from '../../services/security-service';
import states from "../../models/state-list";
import * as moment from 'moment';

import { singleton, observable, computedFrom, BindingEngine, bindable, bindingMode, autoinject } from 'aurelia-framework';
import 'jquery';
import { PhoneValueConverter } from '../../resources/value-converters/phone';
import { WebApiService } from '../../services/web-api-service';
import { BusyService } from '../../services/busy-service';
import { DialogService } from 'aurelia-dialog';



@autoinject()
export class EmailLog {
    constructor(
        private shortDateConverter: ShortDateValueConverter,
        private phoneValueConverter: PhoneValueConverter,
        private dialogService: DialogService,
        private securityService: SecurityService,
        private api: WebApiService,
        private busyService: BusyService
    ) {
        EmailLog.instanceCount++;
        this.eventName = "resize.email-log-grid-" + EmailLog.instanceCount;

        //set up grid options
        this.gridOptions = {
            api: undefined,
            columnDefs: this.columnDefs,
            //pagination controls require v9 or greater.
            pagination: true,
            paginationPageSize: 100,
            //paginationAutoPageSize : true
        };

    }

    static instanceCount: number = 0;
    eventName: string;
    ctrlCEvent: any;    //should hold reference to event handler

    async attached() {
        this.columnDefs.find(o => o.field == "carrierName").hide = !!this.target;
        await this.refresh();
    }

    public async refresh() {
        await this.loadEmails();
    }

    async loadEmails() {
        this.busyService.on();
        const params = !!this.target ? { targetRowId: this.target } : undefined;
        const apiAction = !!this.target ? "GetEmailLogsForTarget" : "GetEmailLogs";
        return this.api.get("Carriers", apiAction, params)
            .then((result) => {
                let response = JSON.parse(result.response);
                this.gridData = response;
            })
            .finally(() => {
                this.busyService.off();
            });
    }


    detached() {
        let $: any = window["$"];
        $(window).off(this.eventName);
        this.gridApi && this.gridApi.removeEventListener("modelUpdated");
        this.gridApi && this.gridApi.gridPanel.eRoot.removeEventListener("keydown", this.ctrlCEvent);
        this.gridApi && this.gridApi.destroy();
    }

    GRID_MIN_HEIGHT: number = 100;

    public gridData = [];
    @bindable({ defaultBindingMode: bindingMode.twoWay }) gridApi;

    columnDefs: Array<any> = [
        { field: "emailId", hide: true, searchType: condition.ConditionFieldType.number },
        {
            field: "", filter: 'text',
            headerRenderer: (params) => `<i class="status-icon fa fa-paper-clip"></i>`,
            cellRenderer: (params) => params.data.attachmentCount > 0 ? `<i class="ml-1 fa fa-paperclip"></i>` : '',
            searchType: condition.ConditionFieldType.string
        }, {
            headerName: "Created", sort: 'desc', field: "insertedOn", filter: 'date',
            cellRenderer: (params) => this.primaryDrillDownRenderer(params, "preview", "date"),
            searchType: condition.ConditionFieldType.date
        },
        {
            headerName: "Recipients",
            field: "recipients",
            filter: 'text',
            searchType: condition.ConditionFieldType.string,
            maxWidth: 500
        },
        {
            headerName: "Subject", field: "subject", filter: 'text',
            searchType: condition.ConditionFieldType.string
        },
        //{ headerName: "Preview", field: "preview", filter: 'text', searchType: condition.ConditionFieldType.string },
        {
            headerName: "Status", field: "status", filter: 'text',
            cellRenderer: (params) => `<i class="status-icon fa ${params.value == 'sent' ? 'fa-check' : params.value == 'error' ? 'fa-exclamation-triangle-o' : 'fa-hourglass-o'}"></i>&nbsp;${params.value}`,
            searchType: condition.ConditionFieldType.string
        },
        {
            headerName: "Sent", field: "emailDate", filter: 'date',
            cellRenderer: (params) => {
                return params.value ? moment(params.value).format("MM/DD/YYYY h:mm a") : '';
            },
            searchType: condition.ConditionFieldType.date
        },
        {
            headerName: "Re-Sent", field: "resentEmailId", filter: 'date',
            cellRenderer: (params) => {
                if (params.data.resentEmailId) {
                    return moment(params.data.resentEmailOn).format("MM/DD/YYYY h:mm a");
                } else {
                    return "";
                }
            },
            searchType: condition.ConditionFieldType.date
        },
        { headerName: "Sent By", field: "insertedBy", filter: 'text', searchType: condition.ConditionFieldType.string },
        {
            headerName: "Carrier", field: "carrierName", filter: 'text',
            cellRenderer: (params) => this.carrierRenderer(params),
            searchType: condition.ConditionFieldType.string
        }
    ];

    rowData = [];
    isGridReady = false;
    gridContainer: any;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) target;

    gridOptions: any;

    carrierRenderer(params: any) {
        return params.value ? `<a route-href href="/work-carrier/${params.data.carrierIntId}">${params.value}</a>` : '';
    }

    primaryDrillDownRenderer(params: any, tooltipField: string, dataType: string) {
        let text = params.value;

        if (dataType == "date") {
            text = moment(params.value).format("MM/DD/YYYY h:mm a");
        }

        let tooltip = "";
        if (tooltipField) {
            let preview = (params.data[tooltipField] || "").replace(/"/gi, "'");
            tooltip = `title = "${preview}"`;
        }

        const html = `<a route-href href="/emails/${params.data.emailId}" ${tooltip} >${text}</a>`;
        return html;
        //var $a = jQuery(html);
        //$a.click(() => {
        //    this.openEmailDialog(params.data.emailId);
        //});
        //return $a[0];
    }


    emailRenderer(params: any) {
        if (params.value) {
            return `<a href="mailto://${params.value}">${params.value}</a>`;
        } else {
            return "";
        }
    }

    numberRenderer(params: any) {
        if (typeof params.value == "number") {
            return params.value.toLocaleString();
        } else {
            return params.value;
        }
    }

    phoneCellRenderer(params: any) {
        const formattedPhone = this.phoneValueConverter.toView(params.value);
        if (formattedPhone) {
            return `<a href="tel://${params.value}">${formattedPhone}</a>`;
        } else {
            return "";
        }
    }

    boolCellRenderer(params: any) {
        if (params.value === true) {
            return "Yes";
        } else if (params.value === false) {
            return "No";
        }
    }

    //return HTML for Anchor element pointing to role-specific carrier details page
    carrierDetailsLinkCellRenderer(params: any, isCarrierName: boolean) {
        //include the route-href parameter so that the addBaseUrlIfMiddleClick (in app.ts) is processed (even though the href attribute is set directly)
        let displayValue = params.value;
        if (displayValue) {
            //users without cmp.view.advanced role view this record in the summary view
            if (this.securityService.hasRole("cmp.view.advanced")) {
                return `<a route-href href=\'/work-carrier/${params.data.id}'>${displayValue}</a>`;
            } else {
                return `<a route-href href=\'/carrier-summary/${params.data.id}'>${displayValue}</a>`;
            }
        } else {
            return null;
        }
    }

    // Copies a string to the clipboard. Must be called from within an 
    // event handler such as click. May return false if it failed, but
    // this is not always possible. Browser support for Chrome 43+, 
    // Firefox 42+, Safari 10+, Edge and IE 10+.
    // IE: The clipboard feature may be disabled by an administrator. By
    // default a prompt is shown the first time the clipboard is 
    // used (per session).
    copyToClipboard(text) {
        if (window["clipboardData"] && window["clipboardData"].setData) {
            // IE specific code path to prevent textarea being shown while dialog is visible.
            return window["clipboardData"].setData("Text", text);

        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            } catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    onReady() {
        this.isGridReady = true;
        this.gridApi = this.gridOptions.api;
        this.autosizeColumns();
        this.resizeGridHeight();

        this.gridApi.gridPanel.eRoot.addEventListener("keydown", this.createCtrlCEventHandler(), false);

        this.gridApi.addEventListener("modelUpdated", (e) => {
            this.modelUpdated();
        });
        this.modelUpdated();

    }

    createCtrlCEventHandler() {
        var self = this;
        return this.ctrlCEvent = (e) => {
            e = e || window.event;
            var key = e.which || e.keyCode; // keyCode detection
            var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false); // ctrl detection

            if (key == 67 && ctrl) {
                self.copyToClipboard(e.target.textContent);
                $["notify"]("Content Copied to clipboard", { className: "success", position: "top center" });
            }
        }
    }

    modelUpdated() {
        this.autosizeColumns();
        //this.storeModel(this.gridApi.getModel());
    }

    // storeModel(model) {
    //     //store current model in local storage so that other pages can use prev/next navigation
    //     var rows = model.rowsToDisplay.map((m) => m.data);
    //     var json = JSON.stringify(rows);
    //     localStorage.setItem("gridRows", json);
    // }

    autosizeColumns() {
        this.gridOptions.api.columnController.autoSizeAllColumns();
    }

    static lastKnownWindowHeight: number;

    resizeGridHeight() {
        let $: any = window["$"];
        let $gridContainer = $(this.gridContainer);
        if (this.gridOptions.api) {

            //when resizing the window, shrink entire container to smallest possible size 
            //  so that subsequent calculations are correct .
            // This is necessary when window is sized to a smaller size.

            //if (windowResized) {
            //    $gridContainer.height(50);
            //}

            var footerHeight = $("footer").outerHeight(true);
            var targetHeight = $(window).height() - $gridContainer.offset().top - footerHeight - 20;
            if (targetHeight < this.GRID_MIN_HEIGHT) {
                targetHeight = this.GRID_MIN_HEIGHT;
            }

            if ($gridContainer.height() !== targetHeight) {

                // Use this information for debugging resize issues
                //$log.trace("RESIZING GRID");
                //$log.trace("==============================");
                //$log.trace(`FOOTER HEIGHT: ${footerHeight}`);
                //$log.trace(`WINDOW HEIGHT: ${$(window).height()}`);
                //$log.trace(`DOCUMENT HEIGHT: ${$(document).height()}`);
                //$log.trace(`GRID CONTAINER offset().top: ${$gridContainer.offset().top}`);
                //$log.trace(`NEW GRID HEIGHT: ${targetHeight}`);


                //resize the kendogrid according to its container
                $gridContainer.stop().animate(
                    { height: targetHeight },
                    {
                        progress: function () {
                            //widget.resize();
                        }, duration: 'fast'
                    });
            }
        }
    }

    static dateFilterParams = {

        // provide comparator function (used when sorting)
        comparator: function (filterLocalDateAtMidnight, cellValue) {

            // In the example application, dates are stored as dd/mm/yyyy
            // We create a Date object for comparison against the filter date
            var cellDate = new Date(cellValue);

            // Now that both parameters are Date objects, we can compare
            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            } else {
                return 0;
            }
        }
    }
}